import { ref, watch } from 'vue'

import { useOnline } from '@vueuse/core'

const PING_URL = `${import.meta.env.VITE_EMT_API_URL}/api/ping`

async function checkConnectivity(maxRetries = 3, delayMs = 2000): Promise<boolean> {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      const res = await fetch(PING_URL, { method: 'HEAD', cache: 'no-store' })
      return res.ok
    } catch {
      if (attempt < maxRetries) {
        await new Promise<void>((resolve) => setTimeout(resolve, delayMs))
      }
    }
  }
  return false
}

export function useRealOnline() {
  const browserOnline = useOnline()
  const online = ref(browserOnline.value)

  watch(browserOnline, async (isOnline) => {
    if (!isOnline) {
      online.value = false
      return
    }
    online.value = await checkConnectivity()
  })

  return online
}
